import {
  MultiLineChart,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${MultiLineChart.Styled.Plot} {
    height: 300px;
  }
`;

export const SingleLegend = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendItemVector = styled.div<{ $color: string }>`
  height: 0;
  width: 16px;
  border-top: 1px solid ${({ $color }) => $color};
`;

export const SingleLegendItemLabel = styled.span`
  ${typographyV2.bodyBase};
`;

export const EtfName = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const EtfTag = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '240px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const MultipleLegend = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const EtfLegendItem = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding-top: 2px;
`;

export const EtfDetails = styled.div`
  display: flex;
  flex-direction: column;
`;
